import { useState } from 'react';

const usePagination = ({ initialPage = 0, initialRowsPerPage = 10 }) => {
  const [page, setPage] = useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  return {
    rowsPerPage,
    setRowsPerPage,
    page,
    setPage,
    onChangePage: (e, page) => {setPage(page);},
    onChangeRowsPerPage: (e) => {
      setPage(0);
      setRowsPerPage(e.target.value);
    },
  };
};

export default usePagination;
